module.exports = __webpack_public_path__ + "img/img4.ad59c21a.svg";